import Modal from "react-bootstrap/Modal";
import AppButton from "../AppButton";

interface AppModalProps {
  title: string;
  open: boolean;
  handleClose: () => void;
  children?: React.ReactNode;
  onSubmit?: () => void;
  isEdit?: boolean;
  action?: string;
  color?: string;
}

export default function AppModal({
  title,
  open,
  handleClose,
  children,
  onSubmit,
  action,
  color,
}: AppModalProps) {
  return (
    <Modal show={open} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>{children}</Modal.Body>

      <Modal.Footer>
        <AppButton
          label="Close"
          onClick={handleClose}
          color="#6c757d"
          fullWidth={false}
          size="sm"
        />

        {action && (
          <AppButton
            label={action}
            onClick={onSubmit}
            color={color}
            fullWidth={false}
            form="userForm"
            size="sm"
          />
        )}
      </Modal.Footer>
    </Modal>
  );
}
